import React from 'react';
import '../_maps.scss';

import Logo from '../../../resources/icons/logo.svg';

const MapMarker = ({children}) => (
    <div className="map-marker">
        <img src={Logo} className="map-marker--logo"/>
        <address className="normal">
            Römerstraße 9 - 13, 6900 Bregenz<br/>
            <a className="plain light normal" href="tel:0043557453500">Tel +43 5574 53500</a> Fax -4<br/>
            <a className="plain light normal" href="mailto:office@radbregenz.at">office@radbregenz.at</a>
        </address>
    </div>
)

export default MapMarker


// WEBPACK FOOTER //
// ./src/components/maps/marker/index.jsx